/*import axios from "axios";

const client = axios.create({
  baseURL: "/api",
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

client.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      const url = error.config?.url || "";
      const isAuthRoute = url.includes("/me") || url.includes("/login") || url.includes("/register");
      if (!isAuthRoute) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default client;*/

import axios from "axios";

let isRefreshingAuth = false;

const client = axios.create({
  baseURL: "/api",
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

// Optional: allow app to mark auth restoration phase
export const setAuthRefreshing = (value) => {
  isRefreshingAuth = value;
};

client.interceptors.response.use(
  response => response,
  error => {
    const status = error.response?.status;
    const url = error.config?.url || "";

    if (status === 401) {
      const isAuthRoute =
        url.includes("/me") ||
        url.includes("/login") ||
        url.includes("/register");

      // 🚨 KEY FIX: don't redirect during auth hydration phase
      if (!isAuthRoute && !isRefreshingAuth) {
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  }
);

export default client;